import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';
import { ErrorMessageModel } from '../../models/error-message.model';

@Component({
    selector: 'aur-string',
    template: `<mat-form-field [formGroup]="formGroup" fxFlex>
    <span *ngIf="control.prefix" matPrefix>{{ control.prefix }}</span>

    <input matInput
        type="{{ control.isPassword ? (hide ? 'password' : 'text') : 'text' }}"
        [formControlName]="control.name"
        [readonly]="control.isReadonly"
        [placeholder]="control.placeholder"
        [required]="control.isRequired"
        [maxlength]="control.maxLength"
        [minlength]="control.minLength" />

    <mat-icon *ngIf="control.isPassword" matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>

    <span *ngIf="control.suffix" matSuffix>{{ control.suffix }}</span>

    <mat-hint *ngIf="control.maxLength" align="end">
        {{ formGroup.controls[control.name].value.length }} / {{ control.maxLength }}
    </mat-hint>

    <mat-error>
        {{ getErrorMessage() }}
    </mat-error>
</mat-form-field>`
})
export class StringComponent {

    @Input() formGroup: FormGroup;
    @Input() control: AurFormControl;

    hide = true;

    getErrorMessage(): string {
        return (<AurFormControl>this.formGroup.controls[this.control.name]).errorMessages
            .filter((errorMessage: ErrorMessageModel) => this.formGroup.controls[this.control.name].hasError(errorMessage.type))
            .map((errorMessage: ErrorMessageModel) => errorMessage.text)[0];
    }
}
